import React from 'react';
import { connect } from 'react-redux';
import fields from '@/constants/fields';
import VocabularyLinkValueContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/VocabularyLinkValueContainer';
import { vocabularyFieldLengths } from '../constants';
import VocabularyLinkInput from '../components/VocabularyLinkInput';

const VocabularyLinkDescription = ({
  description,
  linkUUID,
  exists,
  canRead,
  updateProperties,
  updateErrors,
}) => {
  const updateLinkDescription = (value) => updateProperties(linkUUID, { description: value });

  const error = updateErrors.find((e) => (
    e.context.linkUUID === linkUUID && e.fields.includes(fields.DESCRIPTION)));

  return (
    <VocabularyLinkValueContainer exists={exists} canRead={canRead}>
      <VocabularyLinkInput
        error={error !== undefined}
        fluid
        type="description"
        text={description}
        onChange={updateLinkDescription}
        maxLength={vocabularyFieldLengths.description}
      />
    </VocabularyLinkValueContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyLinkDescription);
